import React from 'react';
import logger from './logger';

function useMarkdown(fileName) {
  const [content, setContent] = React.useState("");

  React.useEffect(()=> {
    fetch(fileName)
        .then((res) => res.text())
        .then((md) => setContent(md))
        .catch(logger.error);
  }, [fileName])

  return content;
}

export default useMarkdown;